<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted montserrat">Shop Information</h6>
            <div class="row">
                <div class="col-sm-12 mb-3">
                    <h3 class="font-weight-700 text-dark" v-text="shop.name"></h3>
                    <h3 class="font-weight-400 text-dark text-sm" v-text="shop.description"></h3>
                </div>
                <div v-if="hasMainBranch" class="col-sm-12 mb-3">
                    <div class="text-xs">Main Branch</div>
                    <router-link :to="`/shops/${ mainBranch.id }/about`" v-slot="{ href, navigate }">
                        <h3 :href="href" @click="navigate" class="font-weight-700 text-dark link-hover-line" v-text="mainBranch.name"></h3>
                    </router-link>
                    <h3 class="font-weight-400 text-dark text-sm" v-text="shop.description"></h3>
                </div>
            </div>
            <h6 class="heading-small text-muted montserrat">Contact Information</h6>
            <div class="row">
                <div class="col-lg-4 col-sm-12 mb-3">
                    <div class="text-xs">Mobile No.</div>
                    <h3 v-if="shop.mobile_no" class="font-weight-700 text-dark text-sm" v-text="shop.mobile_no"></h3>
                    <h3 v-else class="font-weight-400 text-muted text-sm">No mobile no.</h3>
                </div>
                <div class="col-lg-8 col-sm-12 mb-3">
                    <div class="text-xs">Landline No.</div>
                    <h3 v-if="shop.landline_no" class="font-weight-700 text-dark text-sm" v-text="shop.landline_no"></h3>
                    <h3 v-else class="font-weight-400 text-muted text-sm">No landline no.</h3>
                </div>
                <div class="col-lg-4 col-sm-12 mb-3">
                    <div class="text-xs">Email</div>
                    <h3 class="font-weight-700 text-dark text-sm" v-text="shop.email"></h3>
                </div>
                <div class="col-lg-8 col-sm-12 mb-3">
                    <div class="text-xs">Website</div>
                    <a :href="shop.website" class="text-dark">
                        <h3 class="font-weight-700 text-sm link-hover-line" v-text="shop.website"></h3>
                    </a>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import moment from "moment";
import Form from "@models/components/Form";

export default {
    name: "ProfileSection",

    computed: {
        hasMainBranch() {
            return !!this.shop.main_branch_id;
        },
        mainBranch() {
            return this.shop.mainBranch || {};
        },
    },

    data() {
        return {

        };
    },

    props: {
        shop: Object,
    },

    mixins: [mixins],
}
</script>